export default "__VITE_ASSET__197facc5__"